// extracted by mini-css-extract-plugin
export default {"widgetInputForm":"styles_widgetInputForm__M2-La","formLabel":"styles_formLabel__YOT3M"};